import type * as React from "react";

import { SwitchControl } from "@crow/ui/switch";
import { cn } from "../../lib/utils";

/**
 * The design system's switch (`design-system/ui`, copied in `src/crow`): cobalt when on, a white
 * knob in both states. Name it with `aria-label` or a `<label htmlFor={id}>`. On touch screens it
 * grows to a 48 × 28 px target.
 */
function Switch({
	className,
	checked = false,
	onCheckedChange = () => undefined,
	...props
}: Omit<React.ComponentProps<typeof SwitchControl>, "checked" | "onCheckedChange"> & {
	checked?: boolean;
	onCheckedChange?: (checked: boolean) => void;
}) {
	return (
		<SwitchControl
			data-slot="switch"
			checked={checked}
			onCheckedChange={onCheckedChange}
			className={cn(
				"peer pointer-coarse:h-7 pointer-coarse:w-12 pointer-coarse:[&>span]:size-6 pointer-coarse:[&>span[data-state=checked]]:translate-x-[22px]",
				className,
			)}
			{...props}
		/>
	);
}

export { Switch };
